module.exports = __webpack_public_path__ + "assets/img/24.05bc0c12.png";